import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Landing from '../views/Landing.vue'
import StoreLayout from '../views/StoreLayout'
import CartViewMobile from '../views/CartViewMobile'
import DetailFlavor from '../views/DetailFlavor'
import About from '../views/About'
import Colaborations from '../views/Colaborations'
import BranchOffices from '../views/BranchOffices'
import Subscriptions from '../views/Subscription'
import Login from '../views/Login'
import Register from '../views/Register'
import RecoverPassword from '../views/RecoverPassword'
import Checkout from '../views/Checkout'
import Profile from '../views/Profile'
import PaymentLayout from '../views/PaymentLayout'
import SubscriptionPayment from '../views/SubscriptionPayment'
import BuyPayment from '../views/BuyPayment'
import Products from '../views/Products'
import OrderDetail from '../views/OrderDetail'
import ProductsSearch from '../views/ProductsSearch'
import PrivacyPolicy from '../views/PrivacyPolicy'
import DiloConNieve from '../views/DiloConNieve'
import ConfirmationBuy from '../views/ConfirmationBuy'
import HomeService from '../services/home.service'
import store from '../store'

Vue.use(VueRouter)

	const routes = [
		{
			path: '/',
			name: 'StoreLayout',
			component: StoreLayout,
			children: [
        {
          path: '/cambiar-clave',
          name: 'ChangePassword',
          component: () => import('@/views/ChangePassword.vue'),
          meta: { scrollToTop: true }
        },
        {
          path: '/dilo-con-nieve',
          name: 'DiloConNieve',
          component: DiloConNieve,
          meta: { scrollToTop: true },
          beforeEnter(to, from, next) {
            if (store.state.data_home_page.on_dcn === null) {
              HomeService.getDataHomePage().then(response => {
                if (response.data.config_general.on_dcn) {
                  next()
                } else {
                  next({
                    name: "Home"
                  })
                }
              })
            } else {
              if (store.state.data_home_page.on_dcn){
                next()
              } else {
                next({
                  name: "Home"
                })
              }
            }
          }
        },
        {
          path: '/confirmacion-compra',
          name: 'ConfirmationBuy',
          component: ConfirmationBuy,
          meta: { scrollToTop: true }
        },
				{
					path: '',
					name: 'Home',
					component: Home,
					meta: { scrollToTop: true }
        },
        {
          path: '/nuestra-historia',
          name: 'About',
          component: About,
          meta: { scrollToTop: true }
        },
        {
          path: '/colaboraciones',
          name: 'Colaborations',
          component: Colaborations,
          meta: { scrollToTop: true }
        },
        {
          path: '/helado-sabor/:slug/:id',
          name: 'DetailFlavor',
          component: DetailFlavor,
          meta: { scrollToTop: true }
        },
        {
          path: '/sucursales',
          name: 'BranchOffices',
          component: BranchOffices,
          meta: { scrollToTop: true }
        },
        {
          path: '/politicas-privacidad',
          name: 'PrivacyPolicy',
          component: PrivacyPolicy,
          meta: { scrollToTop: true }
        },
        {
          path: '/suscripciones',
          name: 'Subscriptions',
          component: Subscriptions,
          meta: { scrollToTop: true }
        },
        {
          path: '/iniciar-sesion',
          name: 'Login',
          component: Login,
          meta: { scrollToTop: true }
        },
        {
          path: '/registro',
          name: 'Register',
          component: Register,
          meta: { scrollToTop: true }
        },
        {
          path: '/recuperar-contraseña',
          name: 'RecoverPassword',
          component: RecoverPassword,
          meta: { scrollToTop: true }
        },
        {
          path: '/checkout',
          name: 'Checkout',
          component: Checkout,
          meta: { scrollToTop: true }
        },
        {
          path: '/mi-cuenta',
          name: 'Profile',
          component: Profile,
          meta: { scrollToTop: true }
        },
        {
          path: 'lista/productos/:slug/:cat_id',
          name: 'Products',
          component: Products,
          meta: { scrollToTop: true }
        },
        {
          path: 'productos-busqueda',
          name: 'ProductsSearch',
          component: ProductsSearch,
          meta: { scrollToTop: true }
        },
        {
          path: '/carrito-mobile',
          name: 'CartViewMobile',
          component: CartViewMobile,
          meta: { scrollToTop: true }
        }
			]
    },
    {
      path: '/pagos',
      name: 'PaymentLayout',
      component: PaymentLayout,
      children: [
        {
					path: '/procesar-suscripcion',
					name: 'SubscriptionPayment',
					component: SubscriptionPayment
        },
        {
					path: '/procesar-pago',
					name: 'BuyPayment',
					component: BuyPayment
        }
      ]
    },
    {
      path: '/pedido/:order_id/:user_id?',
      name: 'OrderDetail',
      component: OrderDetail
    },
		{
			path: '/sabores',
			name: 'Flavors',
			component: Landing
		}
	]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
		if (to.hash) {
			const offsetTop = document.querySelector(to.hash).offsetTop;
      return scroll({
        top: offsetTop,
        behavior: "auto"
      });
		} else {
			return { x: 0, y: 0 }
		}
	}
})

export default router
